import React from 'react';
import classNames from 'classnames';
import css from './HeroIcons.module.scss';

const HeroIcons = ({ src, alt, text, customClass }) => {
	return (
		<div className={classNames(css.heroIcon, css[customClass])}>
			<img src={`/images/components/hero-icons/${src}`} alt={alt} />
			{Array.isArray(text) ? (
				<>
					<span className="showDesktop">{text[0]}</span>
					<span className="showMobile">{text[1]}</span>
				</>
			) : (
				<span>{text}</span>
			)}
		</div>
	);
};

export default HeroIcons;
